import { render, staticRenderFns } from "./ShopCardModal.vue?vue&type=template&id=8485600e&scoped=true&"
import script from "./ShopCardModal.vue?vue&type=script&lang=js&"
export * from "./ShopCardModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopCardModal.vue?vue&type=style&index=0&id=8485600e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8485600e",
  null
  
)

export default component.exports